import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabGamePage } from './tab-game.page';

import { TabGamePageRoutingModule } from './tab-game-routing.module';
import { LobbyVerticalsModule } from 'src/app/components/casino-lobby/keywords-casino/lobby-verticals.module';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ComponentsModule,
    LobbyVerticalsModule,
    TabGamePageRoutingModule
  ],
  providers:[
    LobbyService
  ],
  declarations: [TabGamePage]
})
export class TabGamePageModule {}
